import {
  inject, observer,
} from 'mobx-react';
import React, {
  Component,
} from 'react';
import GeneralSearchComponent from '../../components/GeneralCRUDComponent/GeneralSearchComponent/GeneralSearchComponent';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  IStatisticsStore,
} from '../../mobx-store/storeInterfaces/statisticsInterface';

interface IProps {
  history?: any;
  statisticsStore?: IStatisticsStore;
}

interface IState {
  pageNumber: number;
  totalNumberOfPages: number;
  pageSize: number;
}

@inject('statisticsStore')
@observer
class NotRegisteredUsers extends Component<IProps, IState> {
  tableHeader: any = [];

  tableData: any[] = [];

  tableCellTypes: TableCellTypes[] = [];

  constructor(props: IProps) {
    super(props);
    this.state = {
      pageNumber: 1,
      totalNumberOfPages: 1,
      pageSize: 50,
    };
  }

  getPreRegisteredTableHeader = () => [
    {
      title: translate('preRegisteredListMemberShipColumnTitle', {
      }),
    },
    {
      title: translate('preRegisteredListPhoneNumberColumnTitle', {
      }),
    },
    {
      title: translate('preRegisteredListVerificationCodeColumnTitle', {
      }),
    },
  ];

  getPreRegisteredTableData = () => this.props.statisticsStore!.preRegisteredUsers;

  getPreRegisteredTableCellTypes = (): TableCellTypes[] => [
    {
      cellType: 'Text',
      key: 'membershipId',
    },
    {
      cellType: 'Text',
      key: 'phoneNumber',
    },
    {
      cellType: 'Text',
      key: 'verificationCode',
    },
  ];

  leftArrowClicked = async () => {
    await this.setState({
      pageNumber: this.state.pageNumber - 1,
    });
    await this.props.statisticsStore!.getPreRegisteredUsers(this.state.pageNumber, this.state.pageSize);
  };

  rightArrowClicked = async () => {
    await this.setState({
      pageNumber: this.state.pageNumber + 1,
    });
    await this.props.statisticsStore!.getPreRegisteredUsers(this.state.pageNumber, this.state.pageSize);
  };

  async componentDidMount() {
    this.props.statisticsStore!.getPreRegisteredUsers(this.state.pageNumber, this.state.pageSize);
    const numberOfPages = Math.ceil(
      this.props.statisticsStore!.totalPreRegisteredUsers / this.state.pageSize,
    );
    await this.setState({
      totalNumberOfPages: numberOfPages,
    });
  }

  handleSearchChanged = (title: any) => {
    this.props.statisticsStore!.getPreRegisteredUsers(this.state.pageNumber, this.state.pageSize, title);
  };

  render() {
    this.tableHeader = this.getPreRegisteredTableHeader();
    this.tableData = this.getPreRegisteredTableData();
    this.tableCellTypes = this.getPreRegisteredTableCellTypes();
    return (
      <div>
        <GeneralSearchComponent
          onSearchClick={this.handleSearchChanged}
          searchBy="title"
        />
        <GeneralTableComponent
          emptyMessage={translate('PreRegisteredListNoUsersMessage', {
          })}
          tableHeader={this.tableHeader}
          tableData={this.tableData}
          tableCellTypes={this.tableCellTypes}
          loading={this.props.statisticsStore!.loading}
          hadPagination
          paginationAction={{
            handleClickLeftArrow: this.leftArrowClicked,
            handleClickRightArrow: this.rightArrowClicked,
            pageNumber: this.state.pageNumber,
            totalNumberOfPages: this.state.totalNumberOfPages,
          }}
        />
      </div>
    );
  }
}

export default NotRegisteredUsers;
